import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : "http://localhost:8000";

export const getActiveAds = async (token, placement = "feed") => {
  try {
    const { data } = await axios.get(`${API_URL}/api/ads/active`, {
      params: { placement },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to load active ads:", error.message);
    return [];
  }
};

export const recordAdImpression = async (adId, token) => {
  try {
    await axios.post(
      `${API_URL}/api/ads/${adId}/impression`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    console.error("Failed to record ad impression:", error.message);
  }
};

export const recordAdClick = async (adId, token) => {
  try {
    await axios.post(
      `${API_URL}/api/ads/${adId}/click`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    console.error("Failed to record ad click:", error.message);
  }
};

export function interleaveFeedAds(posts, ads, interval = 4) {
  const validPosts = (posts || []).filter((post) => post && post.user);
  if (!ads?.length) {
    return validPosts.map((post) => ({ kind: "post", data: post }));
  }

  if (!validPosts.length) {
    return ads.map((ad) => ({ kind: "ad", data: ad }));
  }

  const items = [];
  let adIndex = 0;

  validPosts.forEach((post, index) => {
    items.push({ kind: "post", data: post });
    if ((index + 1) % interval === 0) {
      items.push({ kind: "ad", data: ads[adIndex % ads.length] });
      adIndex += 1;
    }
  });

  if (validPosts.length < interval) {
    items.push({ kind: "ad", data: ads[0] });
  }

  return items;
}
